import type { TFunction } from 'i18next';
import { TSurfaces, ESurfacesTypes } from '../types';

export const getSurfacesTypes = (translate: TFunction): TSurfaces => [
  {
    name: ESurfacesTypes.wall,
    label: translate('calculator.surface.types.wall.label'),
    materialLabel: translate('calculator.surface.types.wall.materialLabel'),
  },
  {
    name: ESurfacesTypes.floor,
    label: translate('calculator.surface.types.floor.label'),
    materialLabel: translate('calculator.surface.types.floor.materialLabel'),
  },
  {
    name: ESurfacesTypes.ceiling,
    label: translate('calculator.surface.types.ceiling.label'),
    materialLabel: translate('calculator.surface.types.ceiling.materialLabel'),
  },
  {
    name: ESurfacesTypes.wall_single,
    label: 'Стена',
    materialLabel: 'Материал стены',
  },
  {
    name: ESurfacesTypes.wall_linear,
    label: 'Стена (по ширине)',
    materialLabel: 'Материал стены (по ширине)',
  },
  {
    name: ESurfacesTypes.land_plot,
    label: 'Земельный участок',
    materialLabel: 'Материал земельного участка',
  },
];
